// extracted by mini-css-extract-plugin
export var actionIcon = "_ss-0";